const ErrorRoute = {
  path: "/404",
  component: () => import("@/components/ErrorLanding/NotFound.vue"),
};

export default ErrorRoute;
